import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles(theme => ({
    tableHeading:{
        backgroundColor: theme.palette.primary.main,
        'fontWeight': 500,
        'lineHeight': '1.5rem'
        
    },
    policyTable:{
        borderRadius:'8px !important',
        fontFamily: 'Source Sans Pro !important',
        background:'#E5E5E5 !important'
    },
    tableTh:{
        color: theme.palette.primary.text+" !important",
        // textTransform:'uppercase !important'
        textAlign: 'left',
        fontFamily: 'Source Sans Pro',
    },
    axaLabel:{
        height: '24px',
        color: '#333333',
        fontFamily: "Source Sans Pro",
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '0',
        lineHeight: '14px',
    },
    AccordionDetails:{
        padding:'0px !important'
    },
    AccordionSummary:{
        padding:'0px !important'
    },
    tableCellHead:{
        textTransform:'uppercase !important',
        color:'white !important',
        fontFamily:'Source Sans Pro !important',
    },
    tableCellBody:{
        fontFamily:'Source Sans Pro !important',
    },
    link:{
        color:theme.palette.primary.text+" !important",
    },
    cardBox:{
        background:'#4472C4',
        color:'#ffffff'
    },
    parentRowColor:{
        background: '#CCCCCC',
    },
    childRowColor:{
        background: '#E5E5E5',
    },
    caretIconColor:{
        color:'#494DF4',
    },
    tableThColor:{
        color: theme.palette.primary.text+" !important",
    },
    cursorPointer:{
        cursor: 'pointer',
    },


}));

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            
            MuiTableCell:{
                head:{
                    fontFamily:'Source Sans Pro !important',
                },
                root:{
                    fontFamily:'Source Sans Pro !important',
                }
            },
            MuiAccordionSummary:{
                content:{
                  margin: "0!important",  
                  "&.Mui-expanded":{
                    margin: "0!important",  
                  }
                },
                root:{
                  minHeight:"auto!important",
                  margin:"16px 0 0",
                  "&.Mui-expanded":{
                    minHeight:"auto!important",
                  }
                }
              },
              MuiTypography:{
                root:{
                  fontFamily:'Source Sans Pro !important',
                }
              },
              MuiPaper:{
                root:{
                    overflow:'hidden !important'
                }
              }
          },
    })
}
